import Vue from 'vue'
import VueI18n from 'vue-i18n'
import push from 'push.js'

import messages from '@/i18n'
import pageTitleNotification from '@/components/flash-title'

const flashTitle = pageTitleNotification()

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

export default function Handler ($store, router) {
  // eslint-disable-next-line
  const add_note = () =>  {
  }

  // eslint-disable-next-line
  const change_password = () => {
    window.location.href = '/login'
  }

  // eslint-disable-next-line
  const close_room = () =>  {
    // console.log('CLOSE ROOM', data)
  }

  // eslint-disable-next-line
  const get_agents = (data) => {
    $store.commit('global/updateAgents', data)
  }

  // eslint-disable-next-line
  const get_header_stats = (data) => {
    $store.commit('user/updateHeaderStats', data)
  }

  // eslint-disable-next-line
  const get_history = (data) => {
    // console.log('HANDLER -> GET ROOM MESSAGES : DATA', data)
    $store.commit('rooms/updateRoomHistory', data)
  }

  // eslint-disable-next-line
  const get_room = (data) => {
    $store.commit('rooms/updateRoom', data)
  }

  // eslint-disable-next-line
  const get_messages = (data) => {
    // console.log('HANDLER -> GET ROOM MESSAGES : DATA', data)
    $store.commit('rooms/updateRoomMessages', data)
  }

  // eslint-disable-next-line
  const get_notes = (data) => {
    // console.log('HANDLER -> GET ROOM MESSAGES : DATA', data)
    $store.commit('rooms/updateRoomNotes', data)
  }

  // eslint-disable-next-line
  const get_products = (data) => {
    $store.commit('custom/updateProducts', data)
  }

  // eslint-disable-next-line
  const get_rooms = (data) => {
    // Code for "unit testing" the rooms list
    // data = {
    //   data: [{
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "created": 1557750290,
    //     "skill": "5f6dfb79-9ab4-4311-8779-b111085ba56b",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "waiting", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID418",
    //       "extra": "",
    //       "skill": "Facturation",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }, {
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "created": 1557750290,
    //     "skill": "ed12d18a-1a1b-434e-ad39-0a232fdd5e3e",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "running", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID417",
    //       "extra": "",
    //       "skill": "SAV",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }, {
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "created": 1557750290,
    //     "skill": "ed12d18a-1a1b-434e-ad39-0a232fdd5e3e",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "transferred", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID410",
    //       "extra": "",
    //       "skill": "SAV",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }, {
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "created": 1557750290,
    //     "skill": "5f6dfb79-9ab4-4311-8779-b111085ba56b",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "running", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID421",
    //       "extra": "",
    //       "skill": "Facturation",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }, {
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a2",
    //     "created": 1557750290,
    //     "skill": "5f6dfb79-9ab4-4311-8779-b111085ba56b",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "waiting", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID419",
    //       "extra": "",
    //       "skill": "Facturation",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }, {
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "created": 1557750290,
    //     "skill": "ed12d18a-1a1b-434e-ad39-0a232fdd5e3e",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "closed", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID006",
    //       "extra": "",
    //       "skill": "SAV",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }, {
    //     "uuid": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "created": 1557750290,
    //     "skill": "ed12d18a-1a1b-434e-ad39-0a232fdd5e3e",
    //     "guest": "2c50531c-2365-45c8-92e1-10ed697118a1",
    //     "agent": null,
    //     "last_waiting": 1557750290,
    //     "last_running": null, "last_closed": null,
    //     "status": "waiting", "unread_msg": 0,
    //     "infos": {
    //       "name": "ID437",
    //       "extra": "",
    //       "skill": "Facturation",
    //       "device": "",
    //       "origin": "",
    //       "browser": "",
    //       "language": "Fran\u00e7ais",
    //       "active_since": 1557750290,
    //       "phone_number": "",
    //       "satisfaction": -1
    //     }
    //   }]
    // }

    $store.commit('rooms/updateList', data)
    let roomTimesFunction = $store.getters['custom/roomTimesFunction']
    if (roomTimesFunction === undefined) {
      roomTimesFunction = 'rooms/initRoomsTimes'
    }
    $store.dispatch(roomTimesFunction)
  }

  // eslint-disable-next-line
  const get_skills = (data) => {
    $store.commit('global/updateSkills', data)
  }

  // eslint-disable-next-line
  const get_stats = (data) => {
    $store.commit('statistics/updateStats', data)
  }

  // eslint-disable-next-line
  const get_csv_stats = (data) => {
    $store.commit('statistics/updateCsvStats', data)
  }

  // eslint-disable-next-line
  const get_supervisor_csv_stats = (data) => {
    $store.commit('statistics/updateCsvStats', data)
  }

  // eslint-disable-next-line
  const get_supervisor_stats = (data) => {
    $store.commit('statistics/updateStats', data)
  }

  // eslint-disable-next-line
  const get_zencalls = (data) => {
    $store.commit('rooms/updateZencallSkills', data)
  }

  // eslint-disable-next-line
  const join_room = () =>  {
    // console.log('HANDLER -> GET ROOMS : DATA', data)
    // $store.commit('rooms/initRoomHistory', data)
  }

  const login = (data) => {
    $store.commit('user/updateToken', data.token)
    if (router.currentRoute.query.redirect === undefined) {
      router.push('/dashboard')
    } else {
      router.push(router.currentRoute.query.redirect)
    }
    $store.dispatch('user/sendUser')
  }

  // eslint-disable-next-line
  const launch_zencall = () => {
  }

  const pause = (data) => {
    $store.commit('user/updatePause', data.pause)
  }

  const ping = () => {
    if (router.currentRoute.path === '/') {
      router.push('/dashboard')
    }
    $store.dispatch('global/answerPing')
  }

  const pong = () => {
    if (router.currentRoute.path === '/') {
      router.push('/dashboard')
    }
  }

  // eslint-disable-next-line
  const reset_password = () => {
  }

  // eslint-disable-next-line
  const room_event = (data) => {
    // console.log('HANDLER -> ROOM EVENT : DATA', data)
    // for (let key in data.data) {
    //   console.log('>>', key, '=', data.data[key])
    // }
    const currentRoom = $store.getters['rooms/getRoom']
    let currentStatus
    let currentUuid
    if (currentRoom) {
      currentStatus = currentRoom.status
      currentUuid = currentRoom.uuid
    }
    if (!router.currentRoute.params.event_uuid) {
      $store.commit('rooms/updateRoomEvent', data)
    }

    if (currentUuid === data.data.room &&
        ['waiting', 'closed'].indexOf(currentStatus) > -1 &&
        data.data.kind === 'guest_msg') {
      // a user has reopen the current room, so we need an update
      $store.dispatch('rooms/sendRoom', router.currentRoute)
    }
    $store.dispatch('rooms/sendRoomsList')
    if ($store.getters['user/getUser'] &&
        $store.getters['user/getUser'].want_notif &&
        $store.getters['user/isAllowedToPush'] === true) {
      if ('data' in data && 'rich_content' in data.data &&
          data.data.rich_content !== null &&
          data.data.rich_content.length > 0) {
        flashTitle.on(`📫 ${i18n.t('doc_title_new_msg')}`, 1000)
        push.create(data.data.rich_content[0].txt)
      }
    }
  }

  // eslint-disable-next-line
  const send_message = () =>  {
  }

  const settings = (data) => {
    $store.commit('user/updateUser', data)
  }

  // eslint-disable-next-line
  const transfer_room = () =>  {
    //
  }

  const unknownCmd = (cmd) => {
    $store.commit('global/updateError', `Unknown command: ${cmd}`)
  }

  return {
    add_note: add_note,
    change_password: change_password,
    close_room: close_room,
    get_agents: get_agents,
    get_header_stats: get_header_stats,
    get_history: get_history,
    get_messages: get_messages,
    get_notes: get_notes,
    get_products: get_products,
    get_room: get_room,
    get_rooms: get_rooms,
    get_skills: get_skills,
    get_csv_stats: get_csv_stats,
    get_stats: get_stats,
    get_supervisor_csv_stats: get_supervisor_csv_stats,
    get_supervisor_stats: get_supervisor_stats,
    get_zencalls: get_zencalls,
    join_room: join_room,
    launch_zencall: launch_zencall,
    login: login,
    pause: pause,
    ping: ping,
    pong: pong,
    reset_password: reset_password,
    room_event: room_event,
    send_message: send_message,
    settings: settings,
    transfer_room: transfer_room,
    unknownCmd: unknownCmd
  }
}
